import axios, { InternalAxiosRequestConfig } from "axios";
import APIBaseURL from '../AppConfig/AppConfig.json'

let configData: InternalAxiosRequestConfig<any>;
const pendingRequests = { count: 0 }; // Track active API requests
const loadingTimers: { [key: string]: NodeJS.Timeout } = {}; // Stores setTimeout IDs

// Create an Axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: APIBaseURL.apiBaseUrl
});

// Request Interceptor to dynamically modify headers
axiosInstance.interceptors.request.use(
  (config) => {
    // pendingRequests.count++;
    
    // // Set a delay of 5 seconds before showing loading
    // const requestKey = config.url || ""; // Unique identifier for request
    // loadingTimers[requestKey] = setTimeout(() => {
    //   showLoading(); // Only show loading after 3 sec
    // }, 3000);

    config.headers = config.headers || {}; // Ensure headers exist
    configData = config;
    // 🔹 Check if `Require-Auth` is explicitly set to "false"
    if (config.headers["Require-Auth"] !== "false") {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    delete config.headers["Require-Auth"]; // Remove before sending request

    return config;
  },
  (error) =>{ 
    // pendingRequests.count--;
    // // Clear the timer before it triggers
    // const requestKey = error.config?.url || "";
    // clearTimeout(loadingTimers[requestKey]);
    // if (pendingRequests.count === 0) hideLoading(); // ✅ Hide when all requests finish
    return Promise.reject(error)
  }
);

// Response Interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    // pendingRequests.count--;
    // // Clear the timer before it triggers
    // const requestKey = response.config.url || "";
    // clearTimeout(loadingTimers[requestKey]);
    // if (pendingRequests.count === 0) hideLoading();
    return response;
  },
  (error) => {
    // pendingRequests.count--;
    //  // Clear the timer before it triggers
    //  const requestKey = error.config?.url || "";
    //  clearTimeout(loadingTimers[requestKey]);
    // if (pendingRequests.count === 0) hideLoading();
    if (error.response) {
      if (error.response.status === 401) {
        window.location.href = `/${configData.headers['X-Tenant']}/SignIn`;
      } else if (error.response.status === 403) {
        console.error("Access denied!");
      } else {
        console.error("API Error:", error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;